// extracted by mini-css-extract-plugin
export default {"button":"MyCardButton_button__-fKLk","inactive":"MyCardButton_inactive__BIEM5","secondaryBtn":"MyCardButton_secondaryBtn__wD8Hc","icon":"MyCardButton_icon__vr8i8"};